module.exports = __webpack_public_path__ + "img/recursos-humanos.e8e72749.jpg";